import { AuthenticatedTemplate , UnauthenticatedTemplate} from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { Container } from "react-bootstrap";
import { LandingPage} from "../components/LandingPage";
import { AdminTop } from "./AdminTop";
import HRManagerMenu from "./HRManagerMenu";


/***
 * Component to detail ID token claims with a description for each claim. For more details on ID token claims, please check the following links:
 * ID token Claims: https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token
 * Optional Claims:  https://docs.microsoft.com/en-us/azure/active-directory/develop/active-directory-optional-claims#v10-and-v20-optional-claims-set
 */
export const Home = () => {
    
    const { instance } = useMsal();    
    const activeAccount = instance.getActiveAccount();
    console.log("Home activeAccount:", activeAccount);
    if (activeAccount) {
        console.log("permissions:", activeAccount.idTokenClaims.extension_PermissionType);
    }

    return (
        <>
            <AuthenticatedTemplate>
                {
                    activeAccount ?
                    <Container>
                        {(activeAccount.idTokenClaims.extension_PermissionType === 3) && (
                            <HRManagerMenu />
                        )}
                        {(activeAccount.idTokenClaims.extension_PermissionType === 4) && (
                            <AdminTop idTokenClaims={activeAccount.idTokenClaims} />
                        )}
                    </Container>
                    :
                    null
                }
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <LandingPage />
            </UnauthenticatedTemplate>
       </>
    )
}